/* eslint-disable */
"use strict";
import configurazioni from "./configurazioniService";
import { fetchTO } from "@/components/helpers";
// const service = process.env.VUE_APP_service_clienti || '' // usato solo per installazione su Windows 32bit (senza IIS con reverse proxy)

var config, service;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_clienti || process.env.VUE_APP_service_clienti;
})();

async function cicleSync(multiplo) {
  try {
    const response = await fetch(`${service}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  try {
    const response = await fetchTO(`${service}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "CLIENTI",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function creaCodiceCliente(ragSoc) {
  const impostazioni = await configurazioni.getConfigurazione(
    "backoffice",
    "impostazioni",
  );
  const tipoNumeratore = impostazioni.clienti.tipoNumeratore;
  var numeratore;
  if (tipoNumeratore === "_") {
    const pattern = /[^a-zA-Z0-9-]+/gi;
    numeratore = ragSoc
      .trim()
      .replace(/\s\s+/g, " ")
      .replace(pattern, "_")
      .toLowerCase();
  } else {
    numeratore = await configurazioni.getNumeratore(tipoNumeratore, true);
  }
  return numeratore;
}

async function searchClienti(searchText) {
  if (!service) return [];
  const response = await fetch(`${service}/search?flt=${searchText}&cl=true`);
  return await response.json();
}

async function getFornitori() {
  const response = await fetch(`${service}/fornitori`); // TODO: da rivedere
  return await response.json();
}

async function searchFornitori(searchText) {
  const response = await fetch(`${service}/search?flt=${searchText}&fr=true`);
  return await response.json();
}

async function getCliente(clienteId) {
  const response = await fetch(`${service}/${clienteId}`);
  return await response.json();
}

async function creaCliente(cliente) {
  const response = await fetch(`${service}/create`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cliente),
  });
  return await response.json();
}

async function getModello() {
  const response = await fetch(`${service}/modello`);
  return await response.json();
}

async function modificaCliente(cliente) {
  const response = await fetch(`${service}/${cliente._id}/update`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(cliente),
  });
  return await response.json();
}

async function getCardFromBarcode(barcode) {
  console.log("clienti--> getCardFromBarcode");
  const response = await fetch(`${service}/cards/${barcode}`);
  return await response.json();
}

async function getFilteredCustomers(filtri, opzioni, versione) {
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(
      `${service}/${versione ? versione + "/" : ""}filter`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      },
    );
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

async function companyInformation(pivaCfOrId, tipoAzienda) {
  try {
    const data = {
      piva_cf_or_id: pivaCfOrId,
      tipoAzienda: tipoAzienda
    };
    const response = await fetch(`${service}/v2/company`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getFilterByDescription(filtri, opzioni, versione) {
  const data = {
    filtri,
    opzioni,
  };
  try {
    const response = await fetch(`${service}/description/filter`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return [];
  }
}

export default {
  cicleSync,
  getRunMode,
  searchClienti,
  getFornitori,
  searchFornitori,
  getCliente,
  creaCodiceCliente,
  creaCliente,
  getModello,
  modificaCliente,
  getCardFromBarcode,
  getFilteredCustomers,
  getFilterByDescription,
  companyInformation,
};
